'use client'

import { STATES_BY_SLUG } from '@/lib/generated/states'
import { getCountryFromRegion } from '@shared/formats/state'
import { FilterChipSelect, FilterChipRange } from './filter-chip'
import { useListingBrowseContext } from '../context/listing-browse-context'
import { useHeroMapContext } from '@/components/home/context/hero-map-context'
import { useFieldConfig } from '@/components/specs/hooks/use-field-config'

export const ALL_PRODUCTS_CONDITION_OPTIONS = [{ label: 'New', value: 'new' }] as const

export function ConditionFilter() {
 const { conditions, setConditions, productType } = useListingBrowseContext()
 const { getConditionOptions } = useFieldConfig(productType || '')

 const conditionOptions =
  productType === null ? ALL_PRODUCTS_CONDITION_OPTIONS : getConditionOptions()

 if (conditionOptions.length === 0) return null

 return (
  <FilterChipSelect
   label="Condition"
   options={[...conditionOptions]}
   value={conditions}
   onChange={setConditions}
   multiple
  />
 )
}

export function PriceFilter() {
 const { priceRange, setPriceRange, intentFilter } = useListingBrowseContext()

 if (intentFilter === 'recycle') return null

 return (
  <FilterChipRange
   label="Price"
   min={priceRange.min}
   max={priceRange.max}
   onChange={(min, max) => setPriceRange({ min, max })}
   prefix="$"
  />
 )
}

export const STATE_OPTIONS = Object.values(STATES_BY_SLUG)
 .filter((state) => getCountryFromRegion(state.code) === 'US')
 .map((state) => ({ label: state.name, value: state.code }))
 .sort((left, right) => left.label.localeCompare(right.label))

export function StateFilter() {
 const { stateCode, setStateCode } = useListingBrowseContext()
 const { setLocation } = useHeroMapContext()

 return (
  <FilterChipSelect
   label="State"
   options={STATE_OPTIONS}
   value={stateCode ? [stateCode] : []}
   onChange={(values) => {
    const nextState = values[0] ?? null
    setStateCode(nextState)
    if (nextState) setLocation(null)
   }}
   multiple={false}
  />
 )
}

export const LISTED_AFTER_OPTIONS = [
 { label: 'Last 24 hours', value: '1' },
 { label: 'Last 7 days', value: '7' },
 { label: 'Last 30 days', value: '30' },
 { label: 'Last 90 days', value: '90' },
] as const

export function RecentlyListedFilter() {
 const { listedAfterDays, setListedAfterDays } = useListingBrowseContext()

 return (
  <FilterChipSelect
   label="Listed"
   options={[...LISTED_AFTER_OPTIONS]}
   value={listedAfterDays !== null ? [String(listedAfterDays)] : []}
   onChange={(values) => {
    const next = values[0]
    setListedAfterDays(next ? Number(next) : null)
   }}
   multiple={false}
  />
 )
}
